import { EmptyChannelHero } from '@/components/contentPane/EmptyChannelHero';
import type { Channel } from '@/types/api';
import type { SavedChannelKind } from '@/lib/savedMessages';

/**
 * Empty-state shown when a freshly-opened channel has no messages yet.
 * Centered and compact. The composer already shows how to start, so the
 * empty view only identifies the conversation and gives one short cue.
 */
export function EmptyChannel(props: { name: string; kind: SavedChannelKind; isVault?: boolean }) {
  return <EmptyChannelHero name={props.name} kind={props.kind} isVault={props.isVault} />;
}

/**
 * Narrow a raw `Channel['type']` down to the values
 * `SavedChannelKind` actually supports. Voice/category channels fall
 * through to `'TEXT'` as a safe display fallback for the saved-messages
 * journal which only renders text-style entries.
 */
export function asSavedChannelKind(t: Channel['type']): SavedChannelKind {
  if (t === 'TEXT' || t === 'ANNOUNCE' || t === 'DM' || t === 'GROUP_DM') {
    return t;
  }
  return 'TEXT';
}
